import React, { useEffect, useState } from 'react';
import BookCard from './BookCard';

interface Books{ 
    _id:string,
    name:string,
    author:string,
    description:string,
    link:string,
    img:string
}

const Elibrary = () => {
    const [search,setSearch] = useState<string>("");
    const [books, setBooks] = useState<Books[]>([]);
    useEffect(() => {
        fetch(`https://taskla-server-hr.onrender.com/books`)
            .then(res => res.json())
            .then(data => setBooks(data))
    }, []) ;
    console.log(books);
    return (
        <div className='mt-28 h-fit'>
            <div className='w-2/4  mx-auto '>
                <input type="text" className='input mb-5 border border-[#9DABF6] dark:border-[#ffd90060] w-full bg-transparent text-lg dark:text-slate-200' placeholder='Search by book name' onChange={event=>{setSearch(event.target.value)}}/>
            </div>
            <div className='max-w-screen-xl mx-auto'>
                <div className='grid md:grid-cols-5'>
                    {books.filter(book =>{
                        if(search == ''){
                            return <p className='text-3xl mt-20 text-black'>Your search result is not match</p>
                        }
                        else if(book.name.toLowerCase().includes(search.toLowerCase())){
                            return book;
                        }
                    }).map(book => <BookCard key={book._id} book={book} />)}
                </div>
            </div>
        </div>
    );
};

export default Elibrary;